import type { CSMSDK } from '@atlassian/customer-service-management-widget-sdk-types/CSMSDK';

import { createSDKQueue } from '../../common/utils/create-sdk-queue';
import { loadCSMSDK } from '../../common/utils/load-js-sdk';

type CSMSDKInit = {
	site: string;
	/**
	 * Temporary support for siteId
	 * Will be removed in the future
	 */
	siteId?: string;
	cloudId?: string;
	widgetId?: string;
};

/**
 * Initialises the CSM SDK
 * Creates a queue to enable commands to be issued before the SDK is loaded
 *
 * If provided with a `widgetId`, the SDK once loaded will attempt to initialise the widget
 *
 * @returns The CSM SDK instance
 */
export const CSM = async ({ site, siteId, cloudId, widgetId }: CSMSDKInit): Promise<CSMSDK | undefined> => {
	if (typeof window === 'undefined') {
		return;
	}

	if (typeof window.CSM === 'undefined') {
		window.CSM = createSDKQueue();
	}

	return await loadCSMSDK({ site, siteId, cloudId, widgetId });
};
